import styled from 'styled-components';
export const ModulePreviewWrapper: any = styled.div`
.float-right{
    float: right;
}
.summaryTable tbody tr td{
    border-top: 1px solid #ddd;
    padding: 10px 10px;
}
.summaryTable tbody tr td:first-child{
    padding-left: 45px;
}
.summaryTable tbody tr td:first-child .summaryLink{
    margin-left: -45px;
    display: inline-block;
    width: 12%;
    vertical-align: inherit;
}
.summaryTable tbody tr td:first-child .summaryDesc{
   display: inline-block;  
   width: 80%;
   margin-top: 0px;
}
.summaryTable tbody tr td p:first-child{
    margin-top: 0px;
}
.summaryLink{
    margin-right: 15px;
}
.radioGroupControl .radioGroup{
    display: flex;
    flex-direction: column;
    align-items: start;
}
.checkboxGroupControl .checkboxGroup{
    display: flex;
    flex-direction: column;
    align-items: start;
}

.questionWrapper{
    // margin-left: 20px;
    padding: 15px 0px;
    border-top: 1px solid #ddd;
}
.commentsBoxWrapper{
    margin-left: 20px;
    margin-top: -5px;
}
.commentsBoxWrapper .commentsBox{
    // background-color: #d9edf7;
    background-color: #e4f5f7!important
    // border-left: 20px solid #a4dbf4;
    border-left: 20px solid #bfdadd;
    border-radius: 0px;
    margin-bottom: 15px;
}
.comment-user{
    font-size: 12px;
    font-style: italic;
}
.comment-post{
    margin: 5px 0px;
}
.comment-date{
    font-size: 12px;
    font-style: italic;
}
.commentsBoxWrapper .commentsBoxRed{
    background-color: #f7a5a5;
    border-left: 20px solid #f78080;
    border-radius: 0px;
    margin-bottom: 15px;
}
.commentsBoxWrapper .commentsBoxRegional{
    background-color: #e4f5f7!important;
    border-left: 20px solid #bfdadd;
    border-radius: 0px;
    margin-bottom: 15px;
}
.commentsBoxWrapper .commentsBadge{
    margin: 10px 0px;
}
.queComments .commentsWrapper {
    display: inline-flex;
    align-content: flex-start;
    align-items: flex-start;
    // margin-top: -12px;
}
.queComments .commentsWrapper .queCommentsText{
    //padding-top: 15px;
    color: #909090;
}
.queComments .commentsWrapper .queCommentsText p{
    /* These are technically the same, but use both */
    overflow-wrap: break-word;
     word-wrap: break-word;

    -ms-word-break: break-all;
    /* This is the dangerous one in WebKit, as it breaks things wherever */
    word-break: break-all;
    /* Instead use this non-standard one: */
    word-break: break-word;

    /* Adds a hyphen where the word breaks, if supported (No Blink) */
    -ms-hyphens: auto;
    -moz-hyphens: auto;
    -webkit-hyphens: auto;
    hyphens: auto;
}

.warningMessage{
    padding: 20px 20px;   
    margin: 0 auto;
    text-align: center;
    border: 1px solid orange;
    background-color: orange;
    color: #fff;
    margin: 15px 0px;
    color: #8a6d3b;
    background-color: #fcf8e3;
    border-color: #faebcc;
}
.warningMessage .warningMessageIcon{
    display: inline-block;
    position: relative;
    top: 5px;  
    margin-right: 10px;
}

.disabledField input{
    background-color: #eaeaea;
    color: #000;
}

.showDataBoxWrapper .showDataBox{
    background-color: #ffff00;
    padding: 10px 10px;
    width: 35%;
    text-align: left;
    margin-top: 5px;
}

.showDataBoxWrapper .showAdminDataBox{
    background-color: #ffff00;
    padding: 10px 10px;
    width: 35%;
    text-align: left;
    margin-top: 5px;
    max-height: 200px;
    overflow-y: auto;
}

.mpnTable{
    margin-bottom: 20px;
}
.mpnTable table tr th{
    font-weight: bold;
    color: #000000;
}
.mpnTable table tr th, .mpnTable table tr td{
    font-size: 16px;
}

.pagePreviewTitle h3{
    font-size: 24px;
}
.submitSurveyVitaminA{
    top: 300px !important;
}
.reviewButtons{
        margin-left: -6pxpx !important;
}
.reviewButtons button {
    margin-right: 10px;
    margin-left: 0px;
    margin-top: 5px;
    margin-bottom: 0px;
    cursor: pointer;
}
.warningIconColor{
    color:red
}
`


// WEBPACK FOOTER //
// ./src/styles/module.preview.tsx